import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problema } from './components/Problema';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Oferta } from './components/Oferta';
import { SistemaTotal } from './components/SistemaTotal';
import { Testimonios } from './components/Testimonios';
import { CostoDeNoTenerlo } from './components/CostoDeNoTenerlo';
import { Garantia } from './components/Garantia';
import { Faq } from './components/Faq';
import { CierreFinal } from './components/CierreFinal';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel('1386464580182190');
  return <div className="w-full overflow-x-hidden bg-forest-900 font-sans" data-id="element-0" data-mp="28suw6sn6u7od">
      <Hero data-id="element-1" data-mp="23w4ek0vqj40u" />
      <main data-id="element-2" data-mp="23ujk0b9f7l2z">
        <TestimonialStrip data-id="element-3" data-mp="23utadzydnu97" />
        <Problema data-id="element-4" data-mp="23ti6m04xmmi3" />
        <Tomos data-id="element-5" data-mp="3ik7e6ay3c1o0" />
        <Bonos data-id="element-6" data-mp="3ikqy1x7ax04o" />
        <Oferta data-id="element-7" data-mp="3ij63w8owfj7c" />
        <SistemaTotal data-id="element-8" data-mp="3ijpcgysnsv8p" />
        <Testimonios data-id="element-9" data-mp="3ii4qhxkeukmg" />
        <CostoDeNoTenerlo data-id="element-10" data-mp="3ml14faz09sk2" />
        <Garantia data-id="element-11" data-mp="3mk86mzi0yde2" />
        <Faq data-id="element-12" data-mp="3mjq1tehaqquj" />
        <CierreFinal data-id="element-13" data-mp="3mjg8pi0yg3km" />
      </main>
      <Footer data-id="element-14" data-mp="3rbrakqf99zft" />
      <PurchasePopup data-id="element-15" data-mp="3rdaqgfx028h2" />
    </div>;
}